<template>
	<div class="content">
		<div class="md-layout">
			<div class="md-layout-item md-medium-size-100 md-size-100">
				<md-card>
					<md-card-content>
						<loading v-if="!loaded" />
						<div class="md-layout" v-if="loaded">
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h3>{{translate(locale.profileInformation)}}</h3>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<div class="md-layout" style="margin-top: 21px">
									<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-25 md-size-15" style="display: flex; justify-content: center; align-items: center;">
										<div class="profile-image-container" style="text-align: center;">
											<img :src="config.cdn + 'images/' + profile.image_logo_url" style="max-width: 120px; max-height: 120px; width: 100%;">
										</div>
									</div>
									<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-75 md-size-85">
										<div class="profile-info-container">
											<div class="profile-title" style="display: flex; flex-direction: row; align-items: center;">
												<h3>{{profile.name}} <span style="color: #353690" v-if="profile.verified"><i class="material-icons">check_circle</i></span></h3>
											</div>
											<div class="profile-type">
												<span class="blue" style="background-color: #fcf1ef; color: #c02e2c; font-weight: bold;">{{translate(profile.profile_type_name)}}</span>
											</div>
											<div class="profile-sector" style="margin: 10px 0">
												<span class="blue" v-for="sector in profile_sub_sector" style="background-color: #eafffb;color: #4b9b9f; margin-right: 12px;font-weight: bold; line-height: 40px;">{{translate(sector.name)}}</span>
											</div>
										</div>
									</div>
									<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
										<div class="profile-description" style="margin-top: 13px; text-align: justify; margin-bottom: 15px;">
											<p>{{profile.description}}</p>
										</div>	
									</div>
									<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-25">
										<div class="profile-contact" style="display: flex; flex-direction: row;">
											<span style="color: #353690"><i class="material-icons">phone</i></span>
											<p style="margin-left: 15px">{{profile.phone}}</p>
										</div>
									</div>
									<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-25">
										<div class="profile-contact" style="display: flex; flex-direction: row;">
											<span style="color: #353690"><i class="material-icons">mail</i></span>
											<p style="margin-left: 15px">{{profile.email}}</p>
										</div>
									</div>
									<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-25">
										<div class="profile-contact" style="display: flex; flex-direction: row;">
											<span style="color: #353690"><i class="material-icons">public</i></span>
											<p style="margin-left: 15px">{{profile.website}}</p>
										</div>
									</div>
									<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-25">
										<div class="profile-contact" style="display: flex; flex-direction: row;">
											<span style="color: #353690"><i class="material-icons">home</i></span>
											<p style="margin-left: 15px">{{profile.address}}, {{translate(profile.district_name)}}, {{translate(profile.province_name)}}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<h3>{{translate(locale.profileStatistics)}}</h3>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25" style="margin-top: 50px">
								<stats-card data-background-color="orange">
									<template slot="header">
										<i class="material-icons">emoji_events</i>
									</template>
									<template slot="content">
										<p class="category">{{translate(locale.total)}}{{translate(locale.profileActivity)}}</p>
										<h3 class="title">{{total_activity}}</h3>
									</template>
								</stats-card>
							</div>

							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25" style="margin-top: 50px">
								<stats-card data-background-color="orange">
									<template slot="header">
										<i class="material-icons">inventory_2</i>
									</template>
									<template slot="content">
										<p class="category">{{translate(locale.total)}}{{translate(locale.productServices)}}</p>
										<h3 class="title">{{total_product}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25" style="margin-top: 50px">
								<stats-card data-background-color="orange">
									<template slot="header">
										<i class="material-icons">campaign</i>
									</template>
									<template slot="content">
										<p class="category">{{translate(locale.total)}}{{translate(locale.requestQuotation)}}</p>
										<h3 class="title">{{total_quotation}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25" style="margin-top: 50px">
								<stats-card data-background-color="orange">
									<template slot="header">
										<i class="material-icons">work</i>
									</template>

									<template slot="content">
										<p class="category">{{translate(locale.total)}}{{translate(locale.jobRecruitment)}}</p>
										<h3 class="title">{{total_job}}</h3>
									</template>
								</stats-card>
							</div>
							<div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25" style="margin-top: 50px">
								<stats-card data-background-color="orange">
									<template slot="header">
										<i class="material-icons">school</i>
									</template>
									<template slot="content">
										<p class="category">{{translate(locale.total)}}{{translate(locale.scholarshipOffer)}}</p>
										<h3 class="title">{{total_scholarship}}</h3>
									</template>
								</stats-card>
							</div>
							<!-- <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25" style="margin-top: 50px">
								<stats-card data-background-color="orange">
									<template slot="header">
										<md-icon>engineering</md-icon>
									</template>
									<template slot="content">
										<p class="category">Consultant & Expert</p>
										<h3 class="title">3125</h3>
									</template>
								</stats-card>
							</div> -->
						</div>
						<!-- <v-select label="name" inputId="id" :options="locationList" v-model="package.location_id"></v-select>
										{{package.location_id}} -->
					</md-card-content>
				</md-card>
			</div>

		</div>
	</div>
</template>

<script>
	import StatsCard from '@/components/Cards/StatsCard'
	export default {
		components: {
			StatsCard
		},
		created() {
			this.getProfile();
		},
		data() {
			return {
				loaded: false,
				profile: {
					image_logo_url: "",
					name: "",
					description: "",
					profile_type_name: "",
					established_year: "",
					total_staff: "",
					email: "",
					phone: "",
					address: "",
					website: "",
					province_name: "",
					district_name: ""
				},
				profile_sub_sector: [],
				total_activity: 0,
				total_product: 0,
				total_quotation: 0,
				total_job: 0,
				total_scholarship: 0
			}
		},
		methods: {
			getProfile(more = false) {
				this.$http.get(this.config.api + "/profile/information/get_view").then(data => {
					this.profile = data.body.data.profile;
					this.profile_sub_sector = data.body.data.profile_sub_sector;
					this.total_activity = data.body.data.total_activity;
					this.total_product = data.body.data.total_product;
					this.total_quotation = data.body.data.total_quotation;
					this.total_job = data.body.data.total_job;
					this.total_scholarship = data.body.data.total_scholarship;
					this.loaded = true;
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/MyProfile.vue